<template>
    <div class="condition-container mt-4" v-if="combinedConsentText">
        <input type="checkbox" id="consent-0" v-model="localCheckedConditions" :value="combinedConsentText"
            @change="emitChecked" />
        <label for="consent-0" class="descliminar mb-2">
            <div>{{ consentParts[0] }}</div>
            <div class="mt-2">{{ consentParts[1] }} <text class="mandatory-mark">*</text></div>
        </label>
    </div>
</template>


<script>
export default {
    props: {
        selected_plan_data: {
            type: Object,
            required: true,
        },
        checkedConditions: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            localCheckedConditions: [...this.checkedConditions],
        };
    },
    computed: {
        consentParts() {
            const conditionString =
                this.selected_plan_data?.supportingData?.userConsent?.[0]?.condition || "";

            const lastNewlineIndex = conditionString.lastIndexOf("\n");

            if (lastNewlineIndex === -1) {
                return [conditionString.trim(), ""];
            }

            const firstPart = conditionString.substring(0, lastNewlineIndex).trim();
            const lastPart = conditionString.substring(lastNewlineIndex + 1).trim();

            return [firstPart, lastPart];
        },
        combinedConsentText() {
            return this.consentParts.filter(Boolean).join(" ");
        },
    },
    methods: {
        emitChecked() {
            this.$emit("update:checkedConditions", this.localCheckedConditions);
            this.$emit("consent-status", this.localCheckedConditions.includes(this.combinedConsentText));
        },
    },
    watch: {
        checkedConditions(newVal) {
            this.localCheckedConditions = [...newVal];
        },
    },
};
</script>





<style scoped lang="scss">
@import "../../assets/scss/components/select-card.scss";
@import "../../assets/scss/components/multi-quotes.scss";
@import "../../assets/scss/components/form-wizard.scss";

.condition-container {
    display: grid;
    grid-template-columns: 20px 1fr;

    input,
    label {
        display: inline-block;
    }

    label {
        transform: translateY(-4px);
    }

    input[type="checkbox"] {
        width: 18px;
        height: 18px;
    }
}

.descliminar {
    font-size: 12px;
    margin-left: 10px;
    text-align: left;
    cursor: pointer;
    line-height: 18px;
    opacity: 0.8;

    &:hover {
        opacity: 1;
    }
}

.dark .descliminar{
    color: $commonColor  !important; 
}

.mandatory-mark {
    color: $alert !important;
}
</style>